var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AGO"},[_c('div',{staticClass:"aog_content",style:({minHeight:_vm.height+'px'}),domProps:{"innerHTML":_vm._s(_vm.articleContent)}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }